import { FC, ReactNode } from "react";
import styles from "./ModalWindow.module.scss";
import { Button } from "../button/Button";
import CrossIcon from "./assets/CrossIcon.svg";
import clsx from "clsx";

interface ModalWindowProps {
  children?: ReactNode;
  type?: "info" | "action";
  dataTestId?: string;
  close?: () => void;
  onAccept?: () => void;
  onCancel?: () => void;
  buttonsPosition?: "right" | "left" | "middle";
  acceptButtonText?: string;
  cancelButtonText?: string;
  noPaddings?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
  opaqueBackdrop?: boolean;
}

export const ModalWindow: FC<ModalWindowProps> = ({
  children,
  type = "action",
  dataTestId,
  close,
  onAccept,
  onCancel,
  buttonsPosition = "middle",
  acceptButtonText,
  cancelButtonText,
  noPaddings = false,
  isLoading = false,
  fullWidth = false,
  opaqueBackdrop = false,
}) => {
  return (
    <div
      className={clsx(styles.modalWrapper, {
        [styles.modalWrapper_opaque]: opaqueBackdrop,
      })}
      {...(dataTestId ? { "data-testid": dataTestId } : {})}
    >
      <div
        className={clsx(styles.modalBlock, {
          [styles.noPaddings]: noPaddings,
          [styles.fullWidth]: fullWidth,
        })}
      >
        {close && (
          <div className={styles.crossBtn} onClick={close}>
            <CrossIcon width={24} />
          </div>
        )}
        {children}
        {type === "action" && (
          <div className={clsx(styles.modalButtons, styles[buttonsPosition])}>
            {onCancel && (
              <Button
                buttontStyle="cancelBtn"
                name={cancelButtonText ?? "Отмена"}
                onClick={onCancel}
                disabled={isLoading}
              />
            )}
            {onAccept && (
              <Button
                buttontStyle="default"
                name={acceptButtonText ?? "Да"}
                onClick={onAccept}
                disabled={isLoading}
                isLoading={isLoading}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
